<template>
  <div v-if="articles.length" class="block-news">
    <div class="news-grid">
      <article v-for="a in articles" :key="a.id" class="news-item">
        <div class="article-meta">
          <time v-if="a.date" class="article-date">{{ formatDate(a.date) }}</time>
          <span v-if="a.category" class="article-category">{{ a.category }}</span>
        </div>
        <a :href="pathName(a.url)" class="article-title">{{ a.title }}</a>
      </article>
    </div>
  </div>
</template>

<script setup>
import axios from 'axios'

const props = defineProps(['block'])
const lang = document.documentElement.lang

const articles = ref([])

function formatDate(str) {
  if (!str) return ''
  const d = new Date(str + 'T12:00:00')
  return isNaN(d) ? str : `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`
}

function refToQuery(ref) {
  return ref.startsWith('page://') ? `kirby.page("${ref}")` : `page("${ref}")`
}

onMounted(async () => {
  const refs = yamlToArray(props.block?.content?.items)
  if (!refs.length) return

  const lc = (f) => lang ? `page.content("${lang}").${f}` : `page.content.${f}`
  const articleSelect = {
    id: true,
    title: lc('title'),
    url: lang ? `page.url("${lang}")` : true,
    date: lc('date'),
    category: lc('category'),
  }

  // Build one KQL select key per page reference so all resolve in a single request
  const select = {}
  refs.forEach((ref, i) => {
    select[`item${i}`] = { query: refToQuery(ref), select: articleSelect }
  })

  const { data } = await axios.post('/api/cachedKQL', { select })
  articles.value = Object.values(cleanUpJSON(data.result)).filter(Boolean)
})
</script>

<style scoped>
.news-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 2rem;
}

.news-item {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1.5rem;
  border: 1px solid var(--fg-20, currentColor);
}

.article-meta {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;
  font-size: 0.85rem;
  opacity: 0.6;
}

.article-date {
  font-variant-numeric: tabular-nums;
}

.article-category {
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-size: 0.75rem;
}

.article-title {
  font-size: 1.2rem;
  line-height: 1.35;
  font-weight: 500;
}
</style>
